import { observer } from "mobx-react-lite";
import React from "react";
import useThemeService from "../../services/theme-service/ThemeService";
import './Navbar.scss';
import './composition.scss';

export const NavbarActions =  observer(function NavbarActions(props: {children:any}) {
    return (
        <div className="navbar-user-actions">
            {props.children}
        </div>
    )
})

export const NavbarMain =  observer(function NavbarMain(props: {children:any}) {
    const { themeClass } = useThemeService();

    return (
        <div className={themeClass(["navbar"])}>
            {props.children}
        </div>
    )
})